// @copyright  2025 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    // Pages
    'other-income.page.edit_draft.title': 'Edit Draft',

    // Buttons
    'other-income.button.cancel': 'Cancel',
    'other-income.button.draft': 'Save Draft',

    // Successes
    'other-income.success.message.other_income_updated': 'Other income has been updated',

    // Errors
    // "Other income" is a mass noun, so both halves of the pluralised pair are the same
    // sentence. That is deliberate, not a copy-paste slip.
    'other-income.error.message.error_loading_page': 'Sorry, there was an error loading other income.| Sorry, there was an error loading other income.',
    'other-income.error.message.error_updating_other_income': 'Error updating other income',
    // The viewer's compact panel says its own, shorter sentence — not the page-level
    // "Sorry, there was an error loading other income." above. Kept verbatim from the
    // pre-i18n panel so nothing a user reads changes; it is a separate key, not a tidy-up.
    'other-income.viewer.error.message.error_loading_page': 'Error loading other income.',

    // Links
    'other-income.link.retry': 'Click here to retry',
    // Likewise the viewer's link is the bare word, not "Click here to retry".
    'other-income.viewer.link.retry': 'Retry',
};
